import {
  IActionNodeApplicationState,
  IActionField,
  ActionSourceOptionType,
} from 'common/actions/integrations/Applications/interfaces'
import { ActionItem } from 'shared/api/common/schemas/actionItem'
import { ApplicationTrigger } from 'shared/api/common/schemas/applicationTrigger'

const getState = (state: RootState): IActionNodeApplicationState => state.integrations.applications

export const getApplicationsTriggers = (state: RootState): ApplicationTrigger[] => {
  return getState(state).triggers
}

export const getSelectedApplicationId = (state: RootState): number | null => {
  return getState(state).selectedApplicationId
}

export const getSelectedItemOid = (state: RootState): string | null => {
  return getState(state).selectedItemOid
}

export const getSelectedItemSource = (state: RootState) => {
  return getState(state).selectedActionSource
}

export const getSelectedActionName = (state: RootState): string | null => {
  return getState(state).selectedActionName
}

export const getSelectedAction = (
  state: RootState,
): { action: ActionItem | null; fetching: boolean } => {
  return {
    action: getState(state).selectedAction,
    fetching: getState(state).actionFetching,
  }
}

export const getActionFields = (state: RootState): IActionField[] => getState(state).actionFields

export const getActionField =
  (fieldName: string) =>
  (state: RootState): IActionField | undefined =>
    getActionFields(state).find((el) => el.field_name === fieldName)

export const getActionMappings = (state: RootState): IActionField[] => getState(state).actionMapping

export const getActionMapping =
  (mappingName: string) =>
  (state: RootState): IActionField | undefined =>
    getActionMappings(state).find((el) => el.field_name === mappingName)

export const getActionSource =
  (sourceName?: string) =>
  (state: RootState): ActionSourceOptionType | undefined =>
    sourceName ? getState(state).actionSources[sourceName] : undefined
